import React, { useEffect, useState } from 'react';

import { Autocomplete } from '@material-ui/lab';
import { Box, Chip, TextField, withStyles } from '@material-ui/core';

import BuzzLabel from '../BuzzLabel/BuzzLabel';

const CustomTextField = withStyles((theme) => ({
  root: {
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        padding: '10px',
      },

    '& .MuiOutlinedInput-root': {
      minHeight: 44,
      maxHeight: 52,

      '& fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.buzzBreadCrumb,
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      '& fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.buzzBorder,
      },
    },
    '& .MuiInputBase-root.Mui-disabled': {
      background: theme.palette.buzzLiteGray,
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.buzzDisableInputColor,
    },

    '& ::before': { display: 'none' },
    '& ::before:focus': { display: 'none' },
    // '& ': { padding: '10px' },
  },
}))(TextField);

function BuzzAutoCompleteMultiSelectInput({
  id,
  label,
  options,
  value = [],
  onChange,
  freeSolo = false,
  required = false,
  disabled = false,
  bgcolor = 'white',
}) {
  const [selectedValue, setSelectedValue] = useState([]);

  useEffect(() => {
    if (!value) return;

    const selectedValues = options.filter(({ value: optionValue }) => {
      return value.includes(optionValue);
    });

    if (freeSolo) {
      for (let val of value) {
        if (!options.map(({ value }) => value).includes(val)) {
          selectedValues.push({ label: val, value: val });
        }
      }
    }

    setSelectedValue(selectedValues);
    // Keyed on the values, not the count: replacing one value with another must re-render.
  }, [(value || []).join('|')]);

  return (
    <Autocomplete
      multiple
      disabled={disabled}
      freeSolo={freeSolo}
      getOptionLabel={({ label }) => label}
      // getOptionSelected={({ value }) => value}
      // disablePortal
      id={id}
      options={options}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <>
          {' '}
          <BuzzLabel label={label} required={required} id={id} />
          <Box
            flex={1}
            bgcolor={bgcolor}
            borderRadius={4}
            border={1}
            borderColor={'#B9B9B9'}>
            <CustomTextField {...params} />
          </Box>
        </>
      )}
      onChange={(e, newValues, action) => {
        // console.log(newValues, action);

        if (freeSolo) {
          onChange(
            newValues.map((val) =>
              typeof val === 'string' || val instanceof String ? val : val.value
            )
          );
        } else onChange(newValues.map(({ value }) => value));
      }}
      value={selectedValue}
    />
  );
}

export default BuzzAutoCompleteMultiSelectInput;
